import { render } from "./EmpresasTable.vue?vue&type=template&id=bcfd1956"
import script from "./EmpresasTable.vue?vue&type=script&lang=js"
export * from "./EmpresasTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__